import styled, { css } from "styled-components";

export const Wrapper = styled.header`
  align-items: center;
  justify-content: space-between;
  padding:24px 16px 0;
  margin: 0 auto;
  position: relative;

   @media (min-width: 768px){
    padding: 32px 64px 0
   }

  @media (min-width: 1200px) {
    display: none;
  }

  @media (min-width: 1440px) {
    padding: 32px 120px 0;
  }

  .ActionBtnTop{
    display: none;
    @media (min-width: 768px){
      display: flex;
    }
  }

  .ActionBtnBottom{
    margin-top: 24px;
    width: 100%;
    @media (min-width: 768px){
      display: none;
    }
  }
`;

export const Modal = styled.div`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  z-index: 2;
`

export const Logo = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const MenuBtn = styled.button`
  z-index: 3;
`;

export const LogoMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  
`
export const LogoMenuRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  gap: 24px;
`

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  right: 0;
  top: 85px;
  gap: 12px;
  background-color: #000;
  width: 350px;
  height: 100vh;
  padding: 8px 16px;
  border: 1px solid rgba(106,157,255,.35);
    border-radius: 16px 0 0px 16px;
  border-right:none;

`;

export const BtnMenu = styled.button`
  ${({ active }) => css`
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid transparent;
    transition: all 0.3s ease-out;
    background-color: transparent;
    text-align: left;

    /* ${active &&
    css`
        background-image:
          linear-gradient(var(--color-002C81), var(--color-002C81)),
          linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
        background-origin: border-box;
        background-clip: padding-box, border-box;
        border: 1px solid transparent;
    `}

    &:hover{
      background-image: linear-gradient(var(--color-003fb9), var(--color-003fb9)),
      linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
      background-origin: border-box;
      background-clip: padding-box, border-box;
      border: 1px solid transparent;
    }  */
  `}
`

export const AMenu = styled.a`
 padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
  transition: all 0.3s ease-out;
  background-color: transparent;
  text-align: left;
`

export const SubMenu = styled.div`
  display: flex;
  flex-direction:column;
  padding-left: 12px;

  color: #e8edff;
  font-size: 14px;
  line-height: 1.2;
`

export const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 257px;
  min-height: 40px;
  border-radius: 8px;
  border-width: 1px;
  padding-top: 8px 16px;
  gap: 8px;
  opacity: 1;
  font-weight: 600;
  font-style: bold;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  background-image: linear-gradient(var(--color-A62AFF), var(--color-A62AFF)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
  background-origin: border-box;
  background-clip: padding-box, border-box;
  border: 1px solid transparent;

  &:hover{
      background-image: linear-gradient(var(--color-3F145E), var(--color-3F145E)),
  linear-gradient(120deg, var(--color-6A9DFF), var(--color-0057FF));
    } 
`